<!--
 * @Description: 收货查询
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: hexy
 * @LastEditTime: 2024-01-09 15:05:49
-->
<template>
  <div class="pages_content table">
    <el-container>
      <el-header>
        <breaDcrumb />
      </el-header>
      <el-main>
        <div class="tabtop">
          <div v-for="(item, index) in contractTypelist" :key="index" @click="choose(item.id)">
            <div :class="currenindex == item.id ? 'active' : 'text'">{{ item.value }}</div>
            <!-- <div v-if=" currenindex !== item.id && currenindex !== item.id + 1 && item.id !== 3 " class="hr"></div> -->
          </div>
        </div>
        <!-- <div class="header_right" @click="showCardNav = !showCardNav">
          <div class="title">搜索</div>
          <div>
            <div :class="{ 'arrowTransform': !showCardNav, 'arrowTransformReturn': showCardNav}">
              <i style="margin-right: .3125rem" class="el-icon-arrow-down"></i>
            </div>
          </div>
        </div> -->
        <div v-show="showCardNav" class="hr"></div>
        <el-collapse-transition>
          <div v-show="showCardNav">
            <div class="search">
              <span style="display: inline-block; margin-bottom: 0.625rem">
                <span style="margin-right: 0.75rem">收货站点</span>
                <el-select v-model="tableParam.receiveStationId" style="width: 7rem" placeholder="请选择" clearable>
                  <el-option v-for="item in stationList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </span>
              <span style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">物料名称</span>
                <el-select v-model="tableParam.rawName" style="width: 7rem" placeholder="请选择" filterable>
                  <el-option v-for="item in rawList" :key="item.id" :label="item.itemName"
                    :value="item.itemName"></el-option>
                </el-select>
              </span>
              <span style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">供应商名称</span>
                <el-input v-model="tableParam.supplier" tplaceholder="请输入" clearable style="width: 7rem"></el-input>
              </span>
              <span style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">订单状态</span>
                <el-select v-model="tableParam.consimentStatus" style="width: 6rem" placeholder="请选择">
                  <el-option v-for="item in statuslist" :key="item.id" :label="item.itemName"
                    :value="item.id"></el-option>
                </el-select>
              </span>
              <!-- <span style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">状态</span>
                <el-select v-model="tableParam.enable" style="width: 6rem" placeholder="请选择">
                  <el-option :key="0" label="禁用" :value="0"></el-option>
                  <el-option :key="1" label="启用" :value="1"></el-option>
                  <el-option :key="1" label="全部" value=""></el-option>
                </el-select>
              </span> -->
              <span v-if="currenindex != 2" style="margin-left: 0.75rem">
                <span style="margin-right: 0.75rem">皮重时间</span>
                <el-date-picker v-model="tableParam.time" style="width: 22rem" unlink-panels
                  value-format="yyyy-MM-dd HH:mm:ss" type="datetimerange" :default-time="['06:00:00', '06:00:00']"
                  range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                  @change="$forceUpdate()"></el-date-picker>
              </span>
              <el-button icon="el-icon-search" size="medium" class="bottom_all but1" @click="searchSubmit()">查
                询</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 0.75rem" @click="init()">重 置</el-button>
              <el-button size="medium" class="bottom_all_two" style="margin-left: 0.75rem"
                @click="tableParamType = true">高级搜索</el-button>
            </div>
          </div>
        </el-collapse-transition>
        <div class="hr"></div>
        <div class="card">
          <div class="card_nav" style="height: 45px">
            <div>
              <el-button v-show="currenindex == 0" size="small" class="bottom_all" style="margin-left: 0"
                @click="selectFromDate()"> 审 核 </el-button>
              <el-button v-show="currenindex == 1" size="small" class="bottom_two" style="margin-left: 0"
                @click="cancelExamine()"> 取消审核 </el-button>
            </div>
            <div>
              <el-dropdown :hide-on-click="false" trigger="click" style="margin: 0 1.25rem">
                <el-link :underline="false">
                  <span class="el-icon--left">
                    <i class="iconfont iconicon_button_filtrate"></i>
                  </span>
                  筛选
                </el-link>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in table" :key="index">
                    <el-checkbox v-model="item.status">{{ item.label }}</el-checkbox>
                  </el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              <el-link :underline="false" @click="load()">
                <span class="el-icon--left">
                  <i class="iconfont iconicon_button_export1"></i>
                </span>
                导出
              </el-link>
            </div>
          </div>
          <div v-loading="tableLoading" class="card_info">
            <el-table :header-cell-style="{ background: '#f3f6f9' }" :row-class-name="tableRowClassName"
              :height="screenHeight - 450" :cell-style="{ borderRight: 'none' }" border style="width: 100%"
              :data="tableData" tooltip-effect="dark" @selection-change="handleSelectionChange">
              <el-table-column align="center" type="selection" width="50" :selectable="checkSelect"></el-table-column>
              <template v-for="(item, index2) in table">
                <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center"
                  :min-width="item.width">
                  <template slot-scope="scope">
                    <span v-if="item.label == '状态'" style="color: #969799">{{ statuslist1 |
                      fromatTable(scope.row.receiveStatus, "itemName", "id") }}</span>
                    <span v-else-if="item.label == '交货量照片'">
                      <el-button v-if="scope.row.imgs" class="bottom_one" size="mini"
                        @click="show1(scope.row.imgs, '交货量照片')">查看</el-button>
                    </span>
                    <span v-else-if="item.label == '材质书'">
                      <el-button v-if="scope.row.materialBookUrl" size="mini" class="bottom_one"
                        @click="show1(scope.row.materialBookUrl, '材质书照片')">查看</el-button>
                    </span>
                    <span v-else-if="item.label == '附件'">
                      <el-button v-if="scope.row.accessoryUrl" size="mini" class="bottom_one"
                        @click="show1(scope.row.accessoryUrl, '附件照片')">查看</el-button>
                    </span>
                    <span v-else-if="item.label == '出厂编号'">
                      <span style="cursor: pointer; color: #00b85c" class="factoryNumber"
                        @click="changeFactoryNumber(scope.row)">{{ scope.row.factoryNumber || "请填写" }}</span>
                    </span>
                    <span v-else-if="item.prop == 'consimentSettlStatus'">
                      <span v-if="scope.row.consimentSettlStatus == 0">未结算</span>
                      <span v-else-if="scope.row.consimentSettlStatus == 1">已结算</span>
                    </span>
                    <span v-else-if="item.prop == 'receiveStationSite'">
                      <span>{{ scope.row.receiveStationSite || scope.row.receiveStation }}</span>
                    </span>
                    <span v-else-if="item.prop == 'auditVolume'" class="auditVolume">
                      <!-- <span>{{scope.row.auditVolume || scope.row.receiveNum}}</span> -->
                      <el-input-number v-model="scope.row.auditVolume" :disabled="currenindex == 2" :precision="2"
                        style="width: 100%" :controls="false" clearable
                        @change="auditVolumeFun(scope.row)"></el-input-number>
                    </span>
                    <span v-else-if="item.label == '是否甲供'">
                      <el-select v-model="scope.row.whetheSupply" :disabled="currenindex != 0" style="width: 100px"
                        placeholder="请选择" @change="whetheSupplyFun(scope.row)">
                        <el-option :key="0" label="否" :value="0"> </el-option>
                        <el-option :key="1" label="是" :value="1" @click.native="isWhetheSupplyFun(scope.row)">
                        </el-option>
                      </el-select>
                    </span>
                    <span v-else-if="item.label == '是否供气'">
                      <el-select v-model="scope.row.supplyGas" :disabled="currenindex != 0" style="width: 100px"
                        placeholder="请选择" @change="supplyGasFun(scope.row)">
                        <el-option :key="0" label="否" :value="0"> </el-option>
                        <el-option :key="1" label="是" :value="1"> </el-option>
                      </el-select>
                    </span>
                    <span v-else-if="item.label == '操作'">
                      <el-dropdown :hide-on-click="false" trigger="click">
                        <el-button size="mini" class="bottom_one">更多</el-button>
                        <el-dropdown-menu slot="dropdown" style="text-align: left">
                          <el-dropdown-item v-if="ButtonList.findIndex(res => res.buttonValue == 'CKYCCL') !== -1">
                            <el-button size="mini" style="margin: 0.3125rem 0" class="bottom_one"
                              @click="gettestresult(scope.row)">查看异常处理</el-button>
                          </el-dropdown-item>
                          <el-dropdown-item v-if="ButtonList.findIndex(res => res.buttonValue == 'CHAKANJG') !== -1">
                            <el-button size="mini" style="margin: 0.3125rem 0" class="bottom_one"
                              @click="open(scope.row, 'Dialog1')">查看结果</el-button>
                          </el-dropdown-item>
                          <el-dropdown-item
                            v-if="scope.row.receiveStatus !== 7 && scope.row.receiveStatus !== 8 && scope.row.receiveStatus !== 0 && scope.row.enable !== 0">
                            <el-button size="mini" style="margin: 0.3125rem 0" class="bottom_one"
                              @click="open(scope.row, 'Dialog2')">检测</el-button>
                          </el-dropdown-item>
                          <!-- <el-dropdown-item
                            v-if="scope.row.receiveStatus !== 7 && scope.row.receiveStatus !== 8 && scope.row.receiveStatus !== 0 && scope.row.enable !== 0 && currenindex !== 2">
                            <el-button size="mini" style="margin: 0.3125rem 0" class="bottom_one"
                              @click="handleCancel(scope.row)">退货</el-button>
                          </el-dropdown-item> -->
                          <el-dropdown-item
                            v-if="currenindex == 0 && scope.row.receiveStatus !== 7 && scope.row.receiveStatus !== 8 && scope.row.receiveStatus !== 0 && scope.row.enable !== 0">
                            <el-button size="mini" class="bottom_one" @click="writeOff(scope.row)">冲销</el-button>
                          </el-dropdown-item>
                          <el-dropdown-item v-if="currenindex == 2">
                            <el-button size="mini" class="bottom_one" @click="deleteGoods(scope.row)">删除</el-button>
                          </el-dropdown-item>
                          <el-dropdown-item v-if="currenindex == 2">
                            <el-button size="mini" style="margin: 0.3125rem 0" class="bottom_one"
                              @click="AddAgainGoods(scope.row)">补录</el-button>
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </span>
                    <span v-else>{{ scope.row[item.prop] }}</span>
                  </template>
                </el-table-column>
              </template>
            </el-table>
          </div>
        </div>
      </el-main>
      <div class="card_bottom">
        <div class="card_bottom_left">
          <div class="top_page_totle">总共{{ total }}条</div>
          <el-pagination :current-page.sync="tableParam.page" :page-size="tableParam.pageSize"
            :page-sizes="[10, 20, 30, 40, 50, 100, 200, 500, 1000]" layout="prev,pager,sizes,next,jumper" :total="total"
            @size-change="sizeChange" @current-change="gettableData()"></el-pagination>
        </div>
        <div>
          <el-button size="mini" icon="el-icon-refresh-right" class="bottom_all_two" @click="gettableData">刷新</el-button>
        </div>
      </div>
    </el-container>
    <!-- 异常处理 -->
    <el-dialog v-dialogDrag :visible.sync="dialoglist.indexOf(activedialog) == 0" width="42.5rem"
      :close-on-click-modal="false" :before-close="resetdialog">
      <span slot="title" class="dialog-title">异常处理</span>
      <div class="dialoginfo">
        <div class="textline">
          <div class="left">异常现象：</div>
          <div class="right">{{ results.phenomena }}</div>
        </div>
        <div class="textline">
          <div>原因：</div>
          <div>{{ results.cause }}</div>
        </div>
        <div class="textline">
          <div>拟处理方式：</div>
          <div>{{ results.processMode }}</div>
        </div>
        <div class="textline">
          <div>条件接收方式：</div>
          <div>{{ results.acceptableConditings }}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetdialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 审核处理 -->
    <el-dialog v-dialogDrag :visible.sync="examineDialog" width="67.5rem" :close-on-click-modal="false"
      :before-close="resetdialog">
      <span slot="title" class="dialog-title">检测结果</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="selectList" tooltip-effect="dark">
          <template v-for="(item, index2) in table_Examine">
            <el-table-column v-if="item.status" :key="index2" :label="item.label" align="center" :min-width="item.width"
              :fixed="item.label == '异常处理' || item.label == '检测结果' || item.label == '操作' ? 'right' : false">
              <template slot-scope="scope">
                <span v-if="item.label == '序号'">{{ scope.$index + 1 }}</span>
                <span v-else-if="item.label == '状态'" style="color: #969799">{{ statuslist1 |
                  fromatTable(scope.row.receiveStatus, "itemName", "id") }}</span>
                <span v-else-if="item.prop == 'approvalStatus'">
                  <span v-if="scope.row.approvalStatus == 1">审批中</span>
                  <span v-else-if="scope.row.approvalStatus == 2">已通过</span>
                  <span v-else-if="scope.row.approvalStatus == 3">不通过</span>
                  <span v-else-if="scope.row.approvalStatus == 4">已撤销</span>
                </span>
                <span v-else-if="item.prop == 'consimentSettlStatus'">
                  <span v-if="scope.row.consimentSettlStatus == 0">未结算</span>
                  <span v-else-if="scope.row.consimentSettlStatus == 1">已结算</span>
                </span>
                <span v-else-if="item.prop == 'receiveStationSite'">
                  <span>{{ scope.row.receiveStationSite || scope.row.receiveStation }}</span>
                </span>
                <span v-else-if="item.prop == 'auditVolume'">
                  <el-input v-model="scope.row.auditVolume" style="width: 90px" clearable placeholder="请输入"></el-input>
                </span>
                <span v-else>{{ scope.row[item.prop] }}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="examineDialog = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 1.5rem" @click="submitApplyExamine(), (examineDialog = false)">提
          交</el-button>
      </span>
    </el-dialog>
    <!-- 检测结果 -->
    <el-dialog v-dialogDrag :visible.sync="dialoglist.indexOf(activedialog) == 1" width="67.5rem"
      :close-on-click-modal="false" :before-close="resetdialog">
      <span slot="title" class="dialog-title">检测结果</span>
      <div class="dialoginfo">
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="arr1" tooltip-effect="dark">
          <el-table-column label="检验ID" align="center">
            <template slot-scope="scope">{{ scope.$index + 1 }}</template>
          </el-table-column>
          <el-table-column label="站点" align="center" prop="station"></el-table-column>
          <el-table-column label="检验类型" align="center" prop="dataType"></el-table-column>
          <el-table-column label="供应商名称" align="center" prop="supplierName"></el-table-column>
          <el-table-column label="物料名称" align="center" prop="rawName"></el-table-column>
          <el-table-column label="规格" align="center" prop="specification"></el-table-column>
          <el-table-column label="交货车辆" align="center" prop="carNo"></el-table-column>
          <el-table-column label="检验结果" align="center">
            <template slot-scope="scope">
              <span class="table_link" @click="open1(scope.row)">查看</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetdialog">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 检测-->
    <el-dialog v-dialogDrag :visible.sync="dialoglist.indexOf(activedialog) == 2" width="42.5rem"
      :close-on-click-modal="false" :before-close="resetdialog">
      <span slot="title" class="dialog-title">检测</span>
      <div class="dialoginfo">
        <el-form ref="reffrom1" :inline="true" :rules="rules1" :model="from1" label-width="6.875rem">
          <el-form-item prop="id">
            <span slot="label">检验类别</span>
            <el-select v-model="from1.id" placeholder="请选择">
              <el-option v-for="(item, index) in arr2" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetdialog">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 1.5rem" @click="submit1()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 检验结果1 -->
    <el-dialog v-dialogDrag :visible.sync="dialog3" width="42.5rem" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">查看</span>
      <div style="padding: 0 1.25rem">
        <div class="dialoginfo-title">
          <div>
            <span>供应商：</span>
            <span>{{ childlow.supplierName }}</span>
          </div>
          <div>
            <span>原物料：</span>
            <span>{{ childlow.rawName }}</span>
          </div>
          <div>
            <span>车牌号：</span>
            <span>{{ childlow.carNo }}</span>
          </div>
        </div>
        <el-table :header-cell-style="{ background: '#f3f6f9' }" :cell-style="{ borderRight: 'none' }" border stripe
          style="width: 100%" :data="arr3.list" tooltip-effect="dark">
          <template v-for="(item, index2) in arr3.title">
            <el-table-column :key="index2" :label="item.name" align="center">
              <template slot-scope="scope">
                <span v-if="index2 == 0">{{ scope.row[0].testItem }}</span>
                <span v-else>
                  <span v-if="scope.row[index2 - 1].type == 2" class="tablt_link"
                    @click="show(scope.row[index2 - 1].testValue)">查看</span>
                  <span v-if="scope.row[index2 - 1].type == 3" class="tablt_link">>{{ scope.row[index2 - 1].symbol }}{{
                    scope.row[index2 - 1].testValue }}</span>
                  <span v-else>{{ scope.row[index2 - 1].testValue }}</span>
                </span>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="dialog3 = false">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 高级搜索 -->
    <el-dialog v-dialogDrag :visible.sync="tableParamType" width="40.625rem" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">高级搜索</span>
      <div class="dialoginfo">
        <el-form ref="reftableParam" :inline="true" :model="tableParam" label-width="6.875rem">
          <el-form-item>
            <span slot="label">供应商名称</span>
            <el-input v-model="tableParam.supplier" tplaceholder="请输入" clearable style="width: 25rem"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">第二次过磅时间</span>
            <el-date-picker v-model="startTimDateEndTimDate" type="datetimerange" unlink-panels
              value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始时间" end-placeholder="结束时间"
              @change="(tableParam.secondTimeOne = startTimDateEndTimDate[0] || ''), (tableParam.secondTimeTwo = startTimDateEndTimDate[1] || '')"></el-date-picker>
          </el-form-item>
          <el-form-item>
            <span slot="label">交货车辆</span>
            <el-input v-model="tableParam.deliveryVehicl" tplaceholder="请输入" clearable style="width: 25rem"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">司机</span>
            <el-input v-model="tableParam.driver" tplaceholder="请输入" clearable style="width: 25rem"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two"
          @click="(tableParamType = false), (tableParam.supplier = ''), (startTimDateEndTimDate = []), (tableParam.secondTimeOne = ''), (tableParam.secondTimeTwo = ''), (tableParam.deliveryVehicl = ''), (tableParam.driver = '')">取
          消</el-button>
        <el-button class="bottom_all" style="margin-left: 1.5rem" @click="gettableData(), (tableParamType = false)">搜
          索</el-button>
      </span>
    </el-dialog>
    <!-- 退货 -->
    <el-dialog v-dialogDrag :visible.sync="returnGoodsDig" width="40.625rem" :close-on-click-modal="false">
      <span slot="title" class="dialog-title">退货</span>
      <div class="dialoginfo">
        <el-form ref="returnGoodsForm" :inline="true" :model="returnGoodsForm" label-width="6.875rem">
          <el-form-item>
            <span slot="label">站点</span>
            <span>{{ low.receiveStation }}</span>
          </el-form-item>
          <el-form-item>
            <span slot="label">原物料</span>
            <span>{{ low.rawMession }}</span>
          </el-form-item>
          <el-form-item :rules="[{ required: true, message: '请输入车牌号', trigger: 'change' }]">
            <span slot="label" style="color: #ff0000">车牌号</span>
            <el-input v-model="returnGoodsForm.deliveryVehicl" tplaceholder="请输入" clearable
              style="width: 25rem"></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">备注信息</span>
            <el-input v-model="returnGoodsForm.returnGoodRemark" :rows="5" resize="none" style="width: 320px"
              type="textarea" placeholder="请输入" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <span slot="label">是否补单</span>
            <el-radio-group v-model="returnGoodsForm.consimentStatus">
              <el-radio :label="0">否</el-radio>
              <el-radio :label="1">是</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item>
            <span style="margin-left: 40px">补单仅用作无人值守异常任务关联，正常任务则为否。</span>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="returnGoodsDig = false">取 消</el-button>
        <el-button :disabled="buttonDisable" class="bottom_all" style="margin-left: 1.5rem" @click="saveReturnGoods()">确
          定</el-button>
      </span>
    </el-dialog>
    <!-- 冲销 -->
    <el-dialog v-dialogDrag :visible.sync="writeOffDig" width="580px" :close-on-click-modal="false">
      <span slot="title" class="dialog-title"> 冲销 </span>
      <div class="dialoginfo">
        <el-form ref="reffromDate" :inline="true" :model="fromDate" label-width="110px" hide-required-asterisk>
          <el-form-item>
            <span slot="label">冲销备注</span>
            <el-input v-model="fromDate.remark" :rows="5" resize="none" style="width: 320px" type="textarea"
              placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="writeOffDig = false">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveWriteOff()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 补录 -->
    <el-dialog v-dialogDrag :visible.sync="addAgainDialog" width="50rem" :close-on-click-modal="false"
      :before-close="resetAgainDialog">
      <span slot="title" class="dialog-title">补录</span>
      <div class="dialoginfo">
        <el-form ref="fromDateAgain" :rules="rulesAgain" :inline="true" :model="fromDateAgain" label-width="110px">
          <el-form-item prop="receiveStation">
            <span slot="label">站点</span>
            <el-input v-model="fromDateAgain.receiveStation" disabled style="width: 200px" clearable />
          </el-form-item>
          <el-form-item prop="rawName">
            <span slot="label">原物料</span>
            <el-input v-model="fromDateAgain.rawName" disabled style="width: 200px" clearable />
          </el-form-item>
          <el-form-item prop="deliveryVehicl">
            <span slot="label">车牌号</span>
            <el-input v-model="fromDateAgain.deliveryVehicl" disabled style="width: 200px" clearable />
          </el-form-item>
          <el-form-item>
            <span slot="label">含水率</span>
            <el-input v-model="fromDateAgain.moistureContent" type="number" style="width: 200px" clearable />
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item prop="factoryTime" :rules="getFactoryTimeRules">
                <span slot="label">水泥出厂时间</span>
                <el-date-picker v-model="fromDateAgain.factoryTime" type="datetime" placeholder="选择日期时间"
                  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="ticketNum"
                :rules="[{ required: rulesAgainRequired, message: '货票量不能为空', trigger: 'blur' }]">
                <span slot="label">货票量</span>
                <el-input v-model="fromDateAgain.ticketNum" style="width: 200px" clearable />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-form-item prop="firstTime">
              <span slot="label">一次过磅时间</span>
              <el-date-picker v-model="fromDateAgain.firstTime" type="datetime" placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item prop="firstWeight">
              <span slot="label">一次过磅量</span>
              <el-input v-model="fromDateAgain.firstWeight" style="width: 200px" clearable />
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item prop="secondTime">
              <span slot="label">二次过磅时间</span>
              <el-date-picker v-model="fromDateAgain.secondTime" type="datetime" placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
            </el-form-item>
            <el-form-item prop="secondWeight">
              <span slot="label">二次过磅量</span>
              <el-input v-model="fromDateAgain.secondWeight" style="width: 200px" clearable />
            </el-form-item>
          </el-row>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="resetAgainDialog">取 消</el-button>
        <el-button class="bottom_all" style="margin-left: 24px" @click="saveAgainList()">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 出厂编码 -->
    <el-dialog :visible="financialCodeVisible" title="编辑出厂编号" width="600px">
      <el-form class="form" :model="financialCodeConfig" label-width="120px" label-position="right"
        hide-required-asterisk>
        <el-form-item>
          <span slot="label" style="color: #ff0000">出厂编号</span>
          <el-input v-model="financialCodeConfig.factoryNumber"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="financialCodeVisible = false">取 消</el-button>
        <el-button class="bottom_all" type="primary" @click="saveFinancialCode">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 甲供工程 -->
    <el-dialog :visible="isWhetheSupplyDig" title="甲供" width="600px">
      <el-form class="form" :model="isWhetheSupplyForm" label-width="120px" label-position="right"
        hide-required-asterisk>
        <el-row>
            <el-col :span="12" :offset="2">
              <span>该供应商为甲供合同，请选择工程信息</span>
            </el-col>
          </el-row>
        <el-form-item style="margin-top: 12px;">
          <span slot="label" style="color: #ff0000">甲供工程</span>
          <el-select ref="select"  v-model="isWhetheSupplyForm.supplyEngineeringId" clearable
                    placeholder="请选择" @change="$nextTick(() => { isWhetheSupplyForm.supplyEngineeringName = $refs.select.selectedLabel })">
                    <el-option v-for="item in whetheSupplyList" :key="item.id" :label="item.engineeringName" :value="item.engineeringId"></el-option>
                </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button class="bottom_all_two" @click="isWhetheSupplyDig = false">取 消</el-button>
        <el-button class="bottom_all" type="primary" @click="saveWhetheSupply">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 查看图片 -->
    <ShowDetails :dialog="imgsDialog" :imgsText="imgsText" :imgList="imgList" :mp4List="mp4List" :fileList="fileList"
      @reset="reset"></ShowDetails>
  </div>
</template>

<script>
import mixin from "@/mixins/ICPSmixin.js";
import ShowDetails from "@/components/showdetails";
import { contractQueryDetailById } from "@/api/GHnumber/contract.js";
import { queryPage, additionalRecording, Download, getConsignmentIssue, getListByPid, save1, getDetail, auditConsiment, cancelAuditConsiment, returnGoods, backConsiment, deleteTask, updateFactoryNumber,queryProjectProvidedByPartyA,updateEngineering } from "@/api/GHnumber/goods.js";
import { setgetList } from "@/api/basicConfig/CPYquality.js";
import { getUserAutList, getDicType } from "@/api/common.js";
import { getUserInfo } from "@/utils/auth";
export default {
  mixins: [mixin],
  components: {
    ShowDetails,
  },
  data() {
    return {
      /*切换状态*/
      examineDialog: false,
      selectList: [],
      contractTypelist: [
        { value: "待交货", id: 2 },
        { value: "未审核", id: 0 },
        { value: "已审核", id: 1 },
        { value: "全部", id: 3 },
      ],
      currenindex: 2,
      imgsDialog: false,
      imgsText: "",
      imgList: [],
      mp4List: [],
      fileList: [],
      startTimDateEndTimDate: [],
      tableParamType: false,
      /*表格增删改查及下载接口*/
      queryPage: queryPage,
      DownloadURL: Download,
      /*表格数据*/
      table: [
        { label: "皮重时间", width: "140", prop: "secondTime", status: true, fiexd: "left" },
        { label: "水泥出厂时间", width: "140", prop: "factoryTime", status: true, fiexd: "left" },
        { label: "收货站点", width: "80", prop: "receiveStation", status: true, fiexd: "left" },
        { label: "库存仓", width: "120", prop: "repertory", status: true, fiexd: "left" },
        { label: "供应商名称", width: "120", prop: "supplier", status: true, fiexd: "left" },
        { label: "合同签订主体", width: "120", prop: "contractSigningSubject", status: true, fiexd: "left" },
        { label: "需求主体", width: "120", prop: "contractSigningSubject1", status: true, fiexd: "left" },
        { label: "协作单位", width: "120", prop: "cooperativeUnit", status: true },
        { label: "地址", width: "120", prop: "mapAdress", status: true },
        { label: "交货车辆", width: "80", prop: "deliveryVehicl", status: true },
        // { label: "物料名称", width: "80", prop: "rawName", status: true , },
        // { label: "物料规格", width: "120", prop: "specification", status: true , },
        { label: "原物料", width: "120", prop: "rawMession", status: true },
        { label: "出厂编号", width: "120", prop: "factoryNumber", status: true },
        { label: "货票量", width: "60", prop: "ticketNum", status: true },
        { label: "毛重", width: "60", prop: "firstWeight", status: true },
        { label: "皮重", width: "60", prop: "secondWeight", status: true },
        { label: "净重", width: "60", prop: "weighingNum", status: true },
        { label: "扣减量", width: "60", prop: "deductionNum", status: true },
        { label: "含水率", width: "60", prop: "moistureContent", status: true },
        { label: "收货量", width: "60", prop: "receiveNum", status: true },
        { label: "审核量", width: "120", prop: "auditVolume", status: true },
        { label: "是否甲供", width: "120", prop: "whetheSupply", status: true },
        { label: "甲供工程", width: "120", prop: "supplyEngineeringName", status: true },
        { label: "是否供气", width: "120", prop: "supplyGas", status: true },
        { label: "结算状态", width: "120", prop: "consimentSettlStatus", status: true },
        { label: "收货地点", width: "180", prop: "receiveStationSite", status: true },
        { label: "交货量照片", width: "120", prop: "", status: true },
        { label: "材质书", width: "120", prop: "", status: true },
        { label: "附件", width: "120", prop: "", status: true },
        { label: "备注类型", width: "120", prop: "remarkType", status: true },
        { label: "更改备注", width: "140", prop: "field1", status: true },
        { label: "冲销备注", width: "140", prop: "backConsimentRemark", status: true },
        { label: "司机", width: "120", prop: "driver", status: true },
        // { label: "实际收货时间", width: "140", prop: "actualReceiveTime", status: true, },
        { label: "毛重时间", width: "140", prop: "firstTime", status: true },

        // { label: "退货审批状态", width: "120", prop: "approvalStatus", status: true },
        { label: "退货备注", width: "150", prop: "returnGoodRemark", status: true },
        { label: "状态", width: "120", prop: "", status: true },
        // { label: "异常处理", width: "140", prop: "", status: true },
        // { label: "异常评价", width: "400", prop: "evaluate", status: true },
        // { label: "检测结果", width: "120", prop: "", status: true },
        { label: "操作", width: "100", prop: "", status: true, fiexd: "right" },
      ],
      /*审核表单数据*/
      table_Examine: [
        { label: "序号", width: "60", prop: "", status: true },
        { label: "收货站点", width: "140", prop: "receiveStation", status: true },
        { label: "库存仓", width: "120", prop: "repertory", status: true },
        { label: "状态", width: "120", prop: "", status: true },
        { label: "供应商名称", width: "160", prop: "supplier", status: true },
        { label: "合同签订主体", width: "160", prop: "contractSigningSubject", status: true },
        { label: "需求主体", width: "160", prop: "contractSigningSubject1", status: true },
        { label: "协作单位", width: "160", prop: "cooperativeUnit", status: true },
        { label: "交货车辆", width: "140", prop: "deliveryVehicl", status: true },
        { label: "物料名称", width: "120", prop: "rawName", status: true },
        { label: "物料规格", width: "120", prop: "specification", status: true },
        { label: "货票量", width: "120", prop: "ticketNum", status: true },
        { label: "一次过磅量", width: "120", prop: "firstWeight", status: true },
        { label: "二次过磅量", width: "120", prop: "secondWeight", status: true },
        { label: "净重", width: "120", prop: "weighingNum", status: true },
        { label: "扣减量", width: "120", prop: "deductionNum", status: true },
        { label: "含水率", width: "120", prop: "moistureContent", status: true },
        { label: "收货量", width: "120", prop: "receiveNum", status: true },
        { label: "审核量", width: "120", prop: "auditVolume", status: true },
        { label: "结算状态", width: "120", prop: "consimentSettlStatus", status: true },
      ],
      /*表单页类型，0为无树状，1为有树状，有树状在el-main加上display:flex*/
      pagesType: 0,
      /*添加表单数据*/
      rules: {
        code: [{ required: true, message: "请输入站点编码", trigger: "blur" }],
      },
      fromDate: {
        code: "",
      },
      fromDateAgain: {
        id: "",
        receiveStation: "",
        receiveStationId: "",
        rawName: "",
        rawNameId: "",
        deliveryVehicl: "",
        ticketNum: "",
        factoryTime: "",
        firstWeight: "",
        firstTime: "",
        secondWeight: "",
        secondTime: "",
      },
      rulesAgainRequired: false, //补录时货票量是否必填
      rulesAgain: {
        firstTime: [{ required: true, message: "一次过磅时间不能为空", trigger: "change" }],
        firstWeight: [{ required: true, message: "一次过磅量不能为空", trigger: "blur" }],
      },
      addAgainDialog: false,
      statuslist1: [
        { itemName: "运输中", id: 1 },
        { itemName: "检验中", id: 2 },
        { itemName: "卸料中", id: 3 },
        { itemName: "内部确认中", id: 4 },
        { itemName: "外部确认中", id: 5 },
        { itemName: "已接受", id: 6 },
        { itemName: "退回", id: 7 },
        { itemName: "已冲销", id: 8 },
      ],
      statuslist: [
        { itemName: "正常", id: 1 },
        { itemName: "已冲销", id: 2 },
        { itemName: "全部", id: "" },
      ],
      dialoglist: ["testresult", "Dialog1", "Dialog2"],
      activedialog: "",
      results: {},
      /*检测*/
      low: {},
      arr1: [],
      rules1: {
        id: [{ required: true, message: "请输入站点编码", trigger: "blur" }],
      },
      from1: {},
      arr2: [],
      /*检验结果1*/
      dialog3: false,
      arr3: [],
      childlow: {},
      stationList: [],
      rawList: [],
      returnGoodsDig: false,
      returnGoodsForm: {
        id: "",
        deliveryVehicl: "",
        consimentStatus: 0,
        returnGoodRemark: "",
      },
      writeOffDig: false,
      fromDate1: {
        backConsimentRemark: "",
        id: "",
      },
      buttonDisable: false,
      financialCodeVisible: false,
      financialCodeConfig: {},
      isWhetheSupplyDig: false,
      isWhetheSupplyForm: {
        id: "",
        whetheSupply: 1,
        supplyEngineeringName: "",
        supplyEngineeringId: "",
      },
      whetheSupplyList:[],
    };
  },
  async created() {
    this.UserInfo = await getUserInfo();
    /*存储拷贝的原初始化fromDate数据*/
    this.tableParam = { ...this.tableParam, pageSize: 10, rawName: "", receiveStationId: "", consimentStatus: 1, supplier: "", secondTimeOne: "", secondTimeTwo: "", deliveryVehicl: "", driver: "", auditStatus: this.currenindex, enable: "", time: [] };
    setgetList().then(res => {
      this.arr2 = res.data.types.filter(res => res.dataType == 1 && res.id !== "3");
    });
    this.stationList = await getUserAutList(true);
    this.init();
    getDicType({ code: "MATname" }).then(res => {
      if (res.code === 1001) {
        this.rawList = res.data.items;
      }
    });
  },
  computed: {
    getFactoryTimeRules() {
      if (this.fromDateAgain.rawNameId === "14ece7eb4b1241b5a4218ddd23b69fd9") {
        return [{ required: true, message: "水泥出厂时间不能为空", trigger: "blur" }];
      } else {
        return [];
      }
    },
  },
  /*
   *copy(data)深拷贝数据,返回拷贝完的数据
   *gettableData获取列表数据
   *load下载
   *SortNum保持序列号
   * UpdateOrDelete禁用，启用，删除
   * submitFromDate保存更新数据
   */
  methods: {
    changeFactoryNumber(row) {
      this.financialCodeVisible = true
      this.financialCodeConfig = {
        factoryNumber: row.factoryNumber,
        id: row.id, // 工程ID
      };
    },
    saveFinancialCode() {
      updateFactoryNumber(this.financialCodeConfig).then(res => {
        if (res.code == 1001) {
          this.$message.success("修改成功!");
          this.financialCodeVisible = false
          this.gettableData();
        }
      });
    },
    deleteGoods(row) {
      this.$confirm("此操作将永久删除该数据是否确认?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteTask({ id: row.id }).then(res => {
            if (res.code == 1001) {
              this.$message.success("删除成功!");
              this.gettableData();
            }
          });
        })
        .catch(() => { });
    },
    AddAgainGoods(row) {
      this.fromDateAgain.firstWeight = row.firstWeight;
      this.fromDateAgain.firstTime = row.firstTime;
      this.fromDateAgain.secondWeight = row.secondWeight;
      this.fromDateAgain.secondTime = row.secondTime;
      this.fromDateAgain.ticketNum = row.ticketNum;
      this.fromDateAgain.receiveStation = row.receiveStation;
      this.fromDateAgain.receiveStationId = row.receiveStationId;
      this.fromDateAgain.id = row.id;
      this.fromDateAgain.rawName = row.rawName;
      this.fromDateAgain.rawNameId = row.rawNameId;
      this.fromDateAgain.deliveryVehicl = row.deliveryVehicl;
      this.fromDateAgain.factoryTime = row.factoryTime;
      this.$set(this.fromDateAgain, "moistureContent", row.moistureContent);
      contractQueryDetailById({ id: row.contractId }).then(res => {
        if (res.code == 1001) {
          // 是水泥则必须传水泥出厂时间，rawNameId为14ece7eb4b1241b5a4218ddd23b69fd9 水泥
          res.data?.list?.forEach(item => {
            if (item.productId == row.rawId && item.settleMethod == 2) {
              this.rulesAgainRequired = true;
            }
          });
          this.addAgainDialog = true;
        }
      });

      console.log(row);
    },
    resetAgainDialog() {
      (this.fromDateAgain = {
        receiveStation: "",
        receiveStationId: "",
        rawName: "",
        rawNameId: "",
        deliveryVehicl: "",
        ticketNum: "",
        factoryTime: "",
        firstWeight: "",
        firstTime: "",
        secondWeight: "",
        secondTime: "",
        moistureContent: "",
        id: "",
      }),
        (this.addAgainDialog = false);
    },
    saveAgainList() {
      this.$refs.fromDateAgain.validate(valid => {
        if (valid) {
          const secondTime = new Date(this.fromDateAgain.secondTime);
          const firstTime = new Date(this.fromDateAgain.firstTime);
          console.log(this.fromDateAgain);
          if (this.fromDateAgain.secondTime && this.fromDateAgain.firstTime) {
            if (secondTime.getTime() > firstTime.getTime()) {
              additionalRecording(this.fromDateAgain).then(res => {
                if (res.code === 1001) {
                  this.$message({
                    message: "操作成功！",
                    type: "success",
                  });
                  this.resetAgainDialog();
                  this.gettableData();
                }
              });
            } else {
              this.$message.warning("第二次过磅时间必须在第一次过磅时间之后!");
            }
          } else {
            additionalRecording(this.fromDateAgain).then(res => {
              if (res.code === 1001) {
                this.$message({
                  message: "操作成功！",
                  type: "success",
                });
                this.resetAgainDialog();
                this.gettableData();
              }
            });
          }
        } else {
          return false;
        }
      });
    },
    saveWriteOff() {
      backConsiment(this.fromDate).then(res => {
        if (res.code == 1001) {
          this.$message.success("保存成功");
          this.gettableData();
          this.writeOffDig = false;
        }
      });
    },
    writeOff(row) {
      this.fromDate.id = row.id;
      (this.fromDate.backConsimentRemark = ""), (this.writeOffDig = true);
    },
    tableRowClassName({ row }) {
      if (row.receiveStatus == 8) {
        return "success-row";
      }
    },
    auditVolumeFun(row) {
      console.log("----", row);
      this.selectList.forEach(item => {
        if (item.id == row.id) {
          console.log("--item--", item);
          item.auditVolume = row.auditVolume;
          return;
        }
      });
    },
    isWhetheSupplyFun(row) {
      this.isWhetheSupplyForm = this.$options.data().isWhetheSupplyForm
      this.isWhetheSupplyForm.id = row.id
      this.isWhetheSupplyForm.supplyEngineeringId = row.supplyEngineeringId
      this.isWhetheSupplyForm.supplyEngineeringName = row.supplyEngineeringName
      this.isWhetheSupplyDig = true
      queryProjectProvidedByPartyA({id:row.rawNeedId}).then(res => {
        if(res.code == 1001) {
          this.whetheSupplyList = res.data
        }
      })
    },
    saveWhetheSupply(){
      if(!this.isWhetheSupplyForm.supplyEngineeringId){
        this.$message.warning('请选择工程!')
        return
      }
      updateEngineering(this.isWhetheSupplyForm).then(res => {
        if(res.code == 1001) {
          this.isWhetheSupplyDig = false
          this.$message.success('保存成功!')
          this.gettableData();
        }
      })
    },
    whetheSupplyFun(row) {
      this.selectList.forEach(item => {
        if (item.id == row.id) {
          item.whetheSupply = row.whetheSupply;
          return;
        }
      });
    },
    supplyGasFun(row) {
      this.selectList.forEach(item => {
        if (item.id == row.id) {
          item.supplyGas = row.supplyGas;
          return;
        }
      });
    },
    cancelExamine() {
      if (this.selectList.length > 0) {
        let paramArr = this.selectList.map(item => {
          return item.id;
        });
        cancelAuditConsiment(paramArr).then(res => {
          if (res.code == 1001) {
            if (!res.data) {
              this.$message({
                message: "审核已取消～",
                type: "warning",
              });
              this.gettableData();
            } else {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
          } else {
            this.$message({
              message: res.codeMsg,
              type: "warning",
            });
          }
        });
      } else {
        this.$message({ message: "请选择需要取消审核数据！", type: "warning" });
      }
    },
    submitApplyExamine() {
      if (this.selectList.length > 0) {
        let zeroVolume = false;
        let rowInfo = "";
        console.log(this.selectList);
        let paramArr = this.selectList.map(item => {
          if (item.auditVolume * 1 == 0 && item.consimentStatus != 2) {
            zeroVolume = true;
            rowInfo = "请确认" + item.secondTime + "-" + item.deliveryVehicl + "审核量为0！";
          }
          return { id: item.id, auditVolume: item.auditVolume, whetheSupply: item.whetheSupply, supplyGas: item.supplyGas };
        });
        if (zeroVolume) {
          this.$message.warning(rowInfo);
          return;
        }
        auditConsiment(paramArr).then(res => {
          if (res.code == 1001) {
            if (!res.data) {
              this.$message({
                message: "审核已经提交",
                type: "warning",
              });
              this.gettableData();
            } else {
              this.$message({
                message: "操作成功",
                type: "success",
              });
            }
          } else {
            this.$message({
              message: res.codeMsg,
              type: "warning",
            });
          }
        });
      }
    },
    selectFromDate() {
      if (this.selectList.length > 0) {
        // this.examineDialog = true
        this.$confirm("是否提交收货数据进行审核?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.submitApplyExamine();
          })
          .catch(() => { });
      } else {
        this.$message({ message: "请选择需要审核数据！", type: "warning" });
      }
    },
    checkSelect(row) {
      if (this.currenindex == 1) {
        if (row.consimentSettlStatus != 1) {
          return true;
        } else {
          return false;
        }
      } else if (this.currenindex == 0) {
        if (row.receiveStatus == 7 || row.receiveStatus == 8 || row.receiveStatus == 0 || row.enable == 0) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    handleSelectionChange(rows) {
      // let itemArr = rows.map(item => {
      //   if (!item.auditVolume) {
      //     item.auditVolume = item.receiveNum*1;
      //   }
      //   return item;
      // });
      // this.selectList = JSON.parse(JSON.stringify(itemArr));
      this.selectList = JSON.parse(JSON.stringify(rows));
      console.log(" ------------ ", this.selectList);
    },
    choose(num) {
      this.currenindex = num;
      this.selectList = [];
      this.tableParam.auditStatus = this.currenindex == 3 ? "" : this.currenindex;
      if (num == 2) {
        this.tableParam.time = []
      } else {
        this.tableParam.time = this.setDefaultTime()
      }
      this.searchSubmit();
    },
    handleCancel(data) {
      // const params = {
      //   type: 1,
      //   supplier: data.supplier,
      //   rawName: data.rawName,
      //   carNo: data.deliveryVehicl,
      //   code: data.code,
      //   id: data.id,
      // };
      // this.$router.push({ name: "cancleOrder", query: params });
      // const self = this;
      // this.$confirm("确定对此数据进行退货?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   cancelButtonClass: "bottom_all_two",
      //   confirmButtonClass: "bottom_all",
      //   type: "warning",
      // }).then(() => {
      //   returnGoods({id: data.id}).then(res => {
      //     if (res.code === 1001) {
      //       self.$message.success('操作成功');
      //       self.gettableData();
      //     }
      //   })
      // }).catch(() => { });
      this.low = data;
      (this.returnGoodsForm = {
        id: data.id,
        deliveryVehicl: data.deliveryVehicl,
        consimentStatus: 0,
        returnGoodRemark: "",
      }),
        (this.returnGoodsDig = true);
    },
    saveReturnGoods() {
      this.buttonDisable = true;
      returnGoods(this.returnGoodsForm)
        .then(res => {
          if (res.code == 1001) {
            this.$message.success("保存成功!");
            this.returnGoodsDig = false;

            this.gettableData();
          }
          this.buttonDisable = false;
        })
        .catch(() => {
          this.buttonDisable = false;
        });
    },
    searchSubmit() {
      this.tableParam.page = 1;
      if (this.tableParam.time?.length) {
        this.tableParam.secondTimeOne = this.tableParam.time[0];
        this.tableParam.secondTimeTwo = this.tableParam.time[1];
      } else {
        this.tableParam.secondTimeOne = ''
        this.tableParam.secondTimeTwo = ''
      }

      this.gettableData();
    },
    /**看图*/
    show1(file, text) {
      let items = file?.split(",").map(res => "/file/" + res);
      this.imgList = items.filter(res => res.includes("type=img"));
      this.mp4List = items.filter(res => res.includes("type=mp4"));
      this.fileList = items.filter(res => res.includes("type=file"));
      this.imgsText = text;
      this.imgsDialog = true;
    },
    reset(key) {
      this[key] = false;
    },
    show(text) {
      this.$alert(text, {
        confirmButtonText: "确定",
        confirmButtonClass: "bottom_all",
        callback: () => { },
      });
    },
    /*打开检测和查看结果弹窗*/
    open(low, key) {
      if (key == "Dialog1") {
        this.activedialog = key;
        getListByPid({ consignmentId: low.id }).then(res => {
          this.arr1 = res.data;
        });
      } else {
        this.activedialog = key;
        this.from1 = {};
        setTimeout(() => {
          this.$refs.reffrom1.clearValidate();
        }, 10);
      }

      this.low = low;
    },
    submit1() {
      this.$refs.reffrom1.validate(valid => {
        if (valid) {
          let data = {
            consignmentId: this.low.id,
            dataType: this.$fromatTable(this.arr2, this.from1.id, "id", "name"),
            dataTypeId: this.from1.id,
            dataTypeStatus: 1,
          };
          save1(data).then(res => {
            if (res.code == 1001) {
              if (!res.data) {
                this.$message({
                  message: "检验报告已经生成",
                  type: "warning",
                });
                return;
              } else {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.activedialog = "";
              }
            } else {
              this.$message({
                message: res.codeMsg,
                type: "warning",
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    /*检验结果1*/
    open1(data) {
      this.childlow = data;
      getDetail({ pid: data.id }).then(res => {
        this.arr3 = res.data;
        this.arr3.title.unshift({ name: "检验项目", sortNum: 0 });
        this.dialog3 = true;
      });
    },
    /*重置数据*/
    init() {
      this.tableParam = {
        rawName: "",
        receiveStationId: "",
        consimentStatus: 1,
        supplier: "",
        secondTimeOne: "",
        secondTimeTwo: "",
        deliveryVehicl: "",
        driver: "",
        enable: "",
        auditStatus: this.currenindex == 3 ? "" : this.currenindex,
        time: [],
        pageSize: this.tableParam.pageSize
      };
      if (this.currenindex != 2) {
        this.tableParam.time = this.setDefaultTime()
      }

      if (this.UserInfo.pointIds.length > 0) {
        this.tableParam.receiveStationId = this.UserInfo.pointIds[0];
      } else {
        this.tableParam.receiveStationId = this.stationList[0].id;
      }
      this.searchSubmit();
    },
    /*获取异常处理*/
    gettestresult(low) {
      getConsignmentIssue({ consignmentId: low.id }).then(res => {
        if (res.data) {
          this.results = res.data;
        } else {
          this.results = {};
        }
        this.activedialog = "testresult";
      });
    },
    resetdialog() {
      this.activedialog = "";
    },
    sizeChange(value) {
      this.tableParam.pageSize = value;
      this.gettableData();
    },
  },
};
</script>

<style lang="scss" scoped>
.dialoginfo-title {
  display: flex;
  justify-content: space-between;
  padding: 0.625rem 0 1.25rem 0;
}

.textline {
  line-height: 2.5rem;
  display: flex;

  >div:first-child {
    width: 6.25rem;
    text-align: right;
  }

  >div:last-child {
    width: 31.25rem;
  }
}

.table_link {
  margin-left: 0.625rem;
  color: $bg_color;
}

.table_link:hover {
  opacity: 0.8;
}

.el-input,
.el-select {
  width: 15rem;
}

.tabtop {
  width: 762px;
}

.success-row {
  background: #fffd87 !important;
}
</style>
<style scoped>
.auditVolume>>>.el-input__inner {
  color: red;
}</style>
